export default function useAnonymousMode() {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get('mode') === 'anonymous';
}
